export default {
  bindings: {
    model: '='
  },
  template: require('../views/billing.details.html')
};
  


// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/journey-ui/payment/components/billing.details.component.js